/* tslint:disable */
/* eslint-disable */
/**
 * Remaster API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
import type { CatalogService } from './CatalogService'
import {
  CatalogServiceFromJSON,
  CatalogServiceFromJSONTyped,
  CatalogServiceToJSON,
} from './CatalogService'

/**
 *
 * @export
 * @interface CatalogObject
 */
export interface CatalogObject {
  /**
   *
   * @type {number}
   * @memberof CatalogObject
   */
  readonly id: number
  /**
   *
   * @type {string}
   * @memberof CatalogObject
   */
  name: string
  /**
   *
   * @type {boolean}
   * @memberof CatalogObject
   */
  isVisible?: boolean | null
  /**
   *
   * @type {string}
   * @memberof CatalogObject
   */
  readonly catalogUniqueId: string
  /**
   *
   * @type {Array<CatalogService>}
   * @memberof CatalogObject
   */
  children: Array<CatalogService> | null
}

/**
 * Check if a given object implements the CatalogObject interface.
 */
export function instanceOfCatalogObject(value: object): boolean {
  let isInstance = true
  isInstance = isInstance && 'id' in value
  isInstance = isInstance && 'name' in value
  isInstance = isInstance && 'catalogUniqueId' in value
  isInstance = isInstance && 'children' in value

  return isInstance
}

export function CatalogObjectFromJSON(json: any): CatalogObject {
  return CatalogObjectFromJSONTyped(json, false)
}

export function CatalogObjectFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): CatalogObject {
  if (json === undefined || json === null) {
    return json
  }
  return {
    id: json['id'],
    name: json['name'],
    isVisible: !exists(json, 'isVisible') ? undefined : json['isVisible'],
    catalogUniqueId: json['catalogUniqueId'],
    children:
      json['children'] === null
        ? null
        : (json['children'] as Array<any>).map(CatalogServiceFromJSON),
  }
}

export function CatalogObjectToJSON(value?: CatalogObject | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    name: value.name,
    isVisible: value.isVisible,
    children:
      value.children === null ? null : (value.children as Array<any>).map(CatalogServiceToJSON),
  }
}
